import React, { Component } from 'react';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

export default class Member extends Component {
	render() {
		const member = this.props.member;
		return (
			<div className="team-member">
				<img className="lazyload" data-src={member.image} alt={ member.name } />
				<div className="name">{ member.name }</div>
				<div className="title">{ member.title }</div>
				<div className="more" onClick={() => this.props.selectMember(member)}>more +</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/team/Member.js